import { render, staticRenderFns } from "./Olympiad.vue?vue&type=template&id=7ac8d6e4&scoped=true&lang=pug&"
import script from "./Olympiad.vue?vue&type=script&lang=js&"
export * from "./Olympiad.vue?vue&type=script&lang=js&"
import style0 from "./Olympiad.vue?vue&type=style&index=0&id=7ac8d6e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac8d6e4",
  null
  
)

export default component.exports